// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"ad3cc953","285":"011e97e5","787":"6af49fc8"}[chunkId] + ".chunk.js";
};